import { useStore } from '@betgames/bg-state-manager';
import { fullScreenStore } from '@bg-shared/business';
import { useMobileView } from '@bg-shared/hooks/useMobileView';
import { partnerSettingsStore } from '@bg-shared/business/PartnerSettings';

export const useFullscreen = () => {
    const isMobileView = useMobileView();
    const isEnabled = useStore(fullScreenStore);
    const isSupported =
        isMobileView && fullScreenStore.isSupported && partnerSettingsStore.isFullscreenEnabled;

    return {
        isFullscreen: isEnabled,
        isFSSupported: isSupported,
    };
};
